import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getRetailerOrBrandToken } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandToken";
import { useStrictLocalization } from "@faire/web/common/localization";
import { useSelfServeContextStore } from "./SelfServeContext";
import { useInitializeEmailField } from "./useInitializeEmailField";
import { useIssueType } from "./useIssueType";
import { useNavigation } from "./useNavigation";
export var useEmailFormState = function useEmailFormState() {
  var _useInitializeEmailFi = useInitializeEmailField(),
    emailUsInitial = _useInitializeEmailFi.emailUsInitial;
  var _useNavigation = useNavigation(),
    goToNextStep = _useNavigation.goToNextStep;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var _useSelfServeContextS = useSelfServeContextStore(["selectedBrandOrder"]),
    _useSelfServeContextS2 = _slicedToArray(_useSelfServeContextS, 1),
    selectedBrandOrder = _useSelfServeContextS2[0].selectedBrandOrder;
  var _useIssueType = useIssueType(),
    issueType = _useIssueType.issueType;
  var retailerOrBrandToken = getRetailerOrBrandToken();
  return {
    emailUsInitial: emailUsInitial,
    goToNextStep: goToNextStep,
    strictLocalize: strictLocalize,
    selectedBrandOrder: selectedBrandOrder,
    issueType: issueType,
    retailerOrBrandToken: retailerOrBrandToken
  };
};